import React, { useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import emailjs from '@emailjs/browser';
import { FaWhatsapp, FaPhoneAlt, FaFacebook, FaLinkedin } from 'react-icons/fa';
import { toast } from 'react-toastify';

function ContactPage() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const refForm = useRef(null);

  const handleNavigateLogin = () => {
    navigate('../login');
  };

  const handleChangeLanguage = () => {
    i18n.language === 'ar' ? i18n.changeLanguage('en') : i18n.changeLanguage('ar');
  };

  const handleNavigateLandingPage = () => {
    navigate('../lp');
  };

  const handleSendMessage = event => {
    event.preventDefault();
    const isSentToast =
      i18n.language === 'ar'
        ? toast.loading('برجاء الانتظار ...')
        : toast.loading('Please wait...');
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        refForm.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        result => {
          toast.update(isSentToast, {
            render: `${
              i18n.language === 'ar'
                ? 'تم إرسال البريد الالكتروني بنجاح'
                : 'Email Sent Successfully'
            }`,
            type: 'success',
            isLoading: false,
            autoClose: 1000,
            theme: 'colored',
          });
          refForm.current.reset();
        },
        error => {
          toast.update(isSentToast, {
            render: `${error.status} - ${error.text}`,
            type: 'error',
            isLoading: false,
            autoClose: 1000,
            theme: 'colored',
          });
        }
      );
  };

  useEffect(() => {
    if (i18n.language === 'ar') {
      window.scrollTo({
        top: 285,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        top: 190,
        behavior: 'smooth',
      });
    }
  }, [i18n.language]);

  return (
    <>
      <nav className='navbar navbar-expand-lg bg-white fixed-top navbar-custom'>
        <div className={`${i18n.language === 'ar' ? 'flex-row-reverse' : ''} container-fluid`}>
          <div className='col-2 text-center mx-auto' onClick={handleNavigateLandingPage}>
            <img src='/Sobol_logo.png' alt='Sobol Logo' height={'50px'} role='button' />
          </div>
          <div
            className={`${
              i18n.language === 'ar' ? 'col text-start ms-2 d-flex' : 'col text-end me-2'
            }`}>
            <div
              className={`d-inline-block landing-page__button text-center py-2 order-2`}
              onClick={handleChangeLanguage}
              role={'button'}>
              <span className='text-capitalize'>{i18n.language === 'ar' ? 'en' : 'ar'}</span>
            </div>
            <div
              className={`d-inline-block landing-page__button text-center py-2 ${
                i18n.language === 'ar' ? 'me-3  order-1' : 'ms-3 order-3'
              } `}
              onClick={handleNavigateLogin}
              role={'button'}>
              <span>{t('landingPage.contact.login')}</span>
            </div>
          </div>
        </div>
      </nav>

      <div className='mx-0 mt-5 row p-5 landing-page__first-section--background'>
        <div className='text-center'>
          <div
            className={`mb-3  landing-page__first-section--title arabic ${
              i18n.language === 'ar' ? 'text-end' : 'text-start'
            }`}>
            {t('contactPage.welcomeSection.title')}
          </div>
          <div
            className={`mb-3  landing-page__first-section--text ${
              i18n.language === 'ar' ? 'text-end arabic' : 'text-start'
            }`}>
            {t('contactPage.welcomeSection.support')}
          </div>
          {i18n.language === 'ar' ? (
            <>
              <div className='mb-3 text-end landing-page__first-section--text arabic'>
                {t('contactPage.welcomeSection.email')}
              </div>
              <div className='mb-3 text-end landing-page__first-section--text arabic'>
                {t('contactPage.welcomeSection.register')}{' '}
                <Link to='../../manual' className='text-decoration-none'>
                  {t('contactPage.welcomeSection.manual')}
                </Link>
                .
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>

      <div className='mx-0 p-5 text-center pt-lg-5 pt-1 mt-2'>
        <div className='row shadow'>
          <div
            className={`d-inline-block col-lg-7 col-12 my-3 ${
              i18n.language === 'ar' ? 'order-lg-first order-last' : 'order-lg-last order-first'
            }`}>
            <form ref={refForm} onSubmit={handleSendMessage}>
              <div className={`mb-3 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
                <label htmlFor='nameAr' className='form-label fs-5 fw-bolder text-dark'>
                  {t('contactPage.contactAndEmailForm.form.name')}
                </label>
                <input
                  type='text'
                  name='user_name'
                  className={`form-control ${
                    i18n.language === 'ar'
                      ? 'contact-page__form-field--ar arabic'
                      : 'contact-page__form-field--en'
                  }`}
                  id='nameAr'
                  required
                />
              </div>
              <div className={`mb-3 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
                <label htmlFor='emailAr' className='form-label fs-5 fw-bolder text-dark'>
                  {t('contactPage.contactAndEmailForm.form.email')}
                </label>
                <input
                  type='email'
                  name='user_email'
                  className={`form-control ${
                    i18n.language === 'ar'
                      ? 'contact-page__form-field--ar arabic'
                      : 'contact-page__form-field--en'
                  }`}
                  id='emailAr'
                  required
                />
              </div>
              <div className={`mb-3 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
                <label htmlFor='phoneAr' className='form-label fs-5 fw-bolder text-dark'>
                  {t('contactPage.contactAndEmailForm.form.mobile')}
                </label>
                <input
                  type='tel'
                  name='user_phone'
                  className={`form-control ${
                    i18n.language === 'ar'
                      ? 'contact-page__form-field--ar arabic'
                      : 'contact-page__form-field--en'
                  }`}
                  id='phoneAr'
                  required
                />
              </div>
              <div className={`mb-3 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
                <label htmlFor='messageAr' className='form-label fs-5 fw-bolder text-dark'>
                  {t('contactPage.contactAndEmailForm.form.message')}
                </label>
                <textarea
                  type='text'
                  name='message'
                  className={`form-control ${
                    i18n.language === 'ar'
                      ? 'contact-page__form-field--ar arabic'
                      : 'contact-page__form-field--en'
                  }`}
                  id='messageAr'
                  required
                />
              </div>

              <button type='submit' className='btn btn-success'>
                {t('contactPage.contactAndEmailForm.form.submitButton')}
              </button>
            </form>
          </div>
          <div
            className={`d-inline-block col-lg-5 col-12 mb-2 px-3 ${
              i18n.language === 'ar' ? 'text-end' : 'text-start'
            }`}>
            <div className=' landing-page__first-section--title mb-2'>
              {t('contactPage.contactAndEmailForm.contact.title')}
            </div>
            <div className='fs-5 fw-bold text-secondary mb-2'>
              {t('contactPage.contactAndEmailForm.contact.sales.title')}
            </div>
            {i18n.language === 'ar' ? (
              <>
                <div className={`my-1 fs-6`}>
                  <a
                    className={`text-decoration-none text-dark ${
                      i18n.language === 'ar' ? 'me-2' : 'ms-2'
                    }`}
                    role={'button'}
                    href='https://wa.me/+201201080081/?text=مرحبًا، أريد الاشتراك في خدمات سبل الخاصة بكم'
                    target='_blank'
                    rel='noreferrer'>
                    01201080081
                  </a>
                  <FaWhatsapp color='green' />
                </div>

                <div className='my-1 fs-6'>
                  <a
                    href='tel:+201201080081
              '
                    className={`text-decoration-none ${i18n.language === 'ar' ? 'me-2' : 'ms-2'}`}>
                    01201080081
                  </a>
                  <FaPhoneAlt className={`mt-1`} color='blue' />
                </div>
                <div className='text-muted my-2'>
                  {t('contactPage.contactAndEmailForm.contact.time')}
                </div>

                <div className='fs-5 fw-bold my-2 text-secondary'>
                  {t('contactPage.contactAndEmailForm.contact.technicalSupport.title')}
                </div>
                <div className='my-1 fs-6'>
                  <a
                    className='text-decoration-none text-dark me-2'
                    role={'button'}
                    href='https://wa.me/+201012751024/?text= مرحبًا، أريد المساعدة'
                    target='_blank'
                    rel='noreferrer'>
                    01012751024
                  </a>
                  <FaWhatsapp color='green' />
                </div>

                <div className='my-1 fs-6'>
                  <a
                    href='tel:+201012751024
              '
                    className='me-2 text-decoration-none'>
                    01012751024
                  </a>
                  <FaPhoneAlt color='blue' />
                </div>
                <div className='text-muted '>
                  {t('contactPage.contactAndEmailForm.contact.time')}
                </div>
                <div className='d-flex flex-row-reverse mt-5 text-start'>
                  <a
                    href='https://www.facebook.com/people/Sobol/100091280832852/?mibextid=LQQJ4d'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='col-1 text-decoration-none'
                    role='button'>
                    <FaFacebook color='blue' size={40} />
                  </a>
                  <a
                    href='https://www.linkedin.com/company/sobol-%D8%B3%D9%8F%D8%A8%D9%8F%D9%84/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='col-1 text-decoration-none'
                    role='button'>
                    <FaLinkedin color='blue' size={40} />
                  </a>
                </div>
              </>
            ) : (
              <>
                <div className={`my-1 fs-6`}>
                  <FaWhatsapp color='green' />
                  <a
                    className={`text-decoration-none text-dark ${
                      i18n.language === 'ar' ? 'me-2' : 'ms-2'
                    }`}
                    role={'button'}
                    href='https://wa.me/+201201080081/?text=Hi%2C+I+am+interested+in+subscribing+as+a+sobol+user'
                    target='_blank'
                    rel='noreferrer'>
                    01201080081
                  </a>
                </div>

                <div className='my-1 fs-6'>
                  <FaPhoneAlt className={`mt-1`} color='blue' />
                  <a
                    href='tel:+201201080081
              '
                    className={`text-decoration-none ${i18n.language === 'ar' ? 'me-2' : 'ms-2'}`}>
                    01201080081
                  </a>
                </div>
                <div className='text-muted my-2'>
                  {t('contactPage.contactAndEmailForm.contact.time')}
                </div>

                <div className='fs-5 fw-bold my-2 text-secondary'>
                  {t('contactPage.contactAndEmailForm.contact.technicalSupport.title')}
                </div>
                <div className='my-1 fs-6'>
                  <FaWhatsapp color='green' />
                  <a
                    className='text-decoration-none text-dark ms-2 fs-6'
                    role={'button'}
                    href='https://wa.me/+201012751024/?text=Hi%2C+I+need+help'
                    target='_blank'
                    rel='noreferrer'>
                    01012751024
                  </a>
                </div>

                <div className='my-1 fs-6'>
                  <FaPhoneAlt color='blue' />
                  <a
                    href='tel:+201012751024
              '
                    className='ms-2 text-decoration-none'>
                    01012751024
                  </a>
                </div>
                <div className='text-muted '>
                  {t('contactPage.contactAndEmailForm.contact.time')}
                </div>
                <div className='row mt-5 text-end'>
                  <a
                    href='https://www.facebook.com/people/Sobol/100091280832852/?mibextid=LQQJ4d'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='col-1 text-decoration-none'
                    role='button'>
                    <FaFacebook color='blue' size={40} />
                  </a>
                  <a
                    href='https://www.linkedin.com/company/sobol-%D8%B3%D9%8F%D8%A8%D9%8F%D9%84/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='col-1 text-decoration-none'
                    role='button'>
                    <FaLinkedin color='blue' size={40} />
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className='m-0 p-5 text-center pt-lg-5 pt-1 mt-2 landing-page__first-section--background'>
        <div className='row'>
          <div
            className={`d-inline-block col-md-6 col-12 mt-2 mb-3 ${
              i18n.language === 'ar' ? 'order-1' : 'order-2'
            }`}>
            <div
              className={`landing-page__first-section--title text-dark mb-3 ${
                i18n.language === 'ar' ? 'text-end' : 'text-start'
              }`}>
              {t('contactPage.GeneralInquiriesSupportSection.generalInquires.title')}
            </div>
            <div
              className={` landing-page__first-section--text ${
                i18n.language === 'ar' ? 'text-end arabic' : ''
              }`}>
              {t('contactPage.GeneralInquiriesSupportSection.generalInquires.messageUs')}{' '}
              <a
                href={`mailto:info@sobol.com?subject=General inquiries&body=${
                  i18n.language === 'ar' ? 'أريد' : 'I want'
                }`}
                className='text-decoration-none fw-bold'>
                info@ssobol.com
              </a>{' '}
              {t('contactPage.GeneralInquiriesSupportSection.generalInquires.reply')}
            </div>
          </div>
          <div
            className={`d-inline-block col-md-6 col-12 mt-2 mb-3 ${
              i18n.language === 'ar' ? 'order-2' : 'order-1'
            }`}>
            <div
              className={`landing-page__first-section--title text-dark mb-3 ${
                i18n.language === 'ar' ? 'text-end' : 'text-start'
              }`}>
              {t('contactPage.GeneralInquiriesSupportSection.technicalSupport.title')}
            </div>
            <div
              className={` landing-page__first-section--text ${
                i18n.language === 'ar' ? 'text-end arabic' : ''
              }`}>
              {t('contactPage.GeneralInquiriesSupportSection.technicalSupport.messageUs')}{' '}
              <a
                href={`mailto:support@sobol.com?subject=support&body=${
                  i18n.language === 'ar' ? 'لدي مشكلة' : 'We have a problem'
                }`}
                className='text-decoration-none fw-bold'>
                support@ssobol.com
              </a>{' '}
              {t('contactPage.GeneralInquiriesSupportSection.technicalSupport.reply')}
            </div>
          </div>
        </div>
      </div>

      {/* 5th section - footer */}
      <div className='m-0 row text-center px-5'>
        <span
          className={`my-2 landing-page__footer--text ${i18n.language === 'ar' ? 'arabic' : ''}`}>
          {t('landingPage.footer.company')}&copy; {t('landingPage.footer.year')}
          {i18n.language === 'ar' ? '،' : ','} {t('landingPage.footer.rights')}.
        </span>
      </div>
    </>
  );
}

export default ContactPage;
